import React, {Component} from 'react';
import {bindActionCreators, Dispatch} from 'redux';
import {connect} from 'react-redux';

import {Toolbar} from 'primereact/toolbar';

import * as PanelActions from '~/frontend/src/actions/panel/common';
import {SetParamAction} from '~/frontend/src/actions/panel/common/setParam';
import * as FinderActions from '~/frontend/src/actions/panel/finderDetail';
import {ComponentProps as DetailProps} from '~/frontend/src/modules/panels/Finder/detail';
import {StoreState} from '~/frontend/src/store';
import {getToolbarComponents, ToolbarComponents, ToolbarLayoutComponents} from '~/frontend/src/utilities/toolbars';
import {__} from '~/shared/src/utilities/messageCatalog';
import User from '~/shared/src/model/User';


const Actions = Object.assign( {}, PanelActions, FinderActions ) as any;
type SetParam = <K extends keyof DetailProps>( panelKey : string, paramKey : K, paramValue : DetailProps[K] ) => SetParamAction;


const defaultProps = {

    /**
     * Should the view options button shown in the toolbar.
     */
    showViewOptionsButton: true as boolean,

    /**
     * The CSS class name(s) to add to the component.
     */
    className: '' as string
};

type DefaultProps = typeof defaultProps;

type Props = {

    /**
     * The uniqueId of the panel the component is used in.
     *
     * Mostly used to extract the components state from the global one
     * and to generate unique dom element ids.
     */
    uid : string;

    /**
     * Show empty (not set) properties.
     */
    showEmptyProperties : boolean;

    /**
     * Should default values shown for properties.
     */
    showPropertyDefaults : boolean;
};

type StateProps = {

    /**
     * The current user.
     *
     * Will be mapped from global state.
     */
    user? : User;
};

/**
 * Function props mapped by mapDispatchToProps
 */
type ActionProps = {
    // common panel actions
    setParam : SetParam
}

type ComponentProps = Partial<DefaultProps> & Props;
type AllProps = DefaultProps & Props & StateProps & ActionProps;

/**
 * PropertiesToolbar
 */
class PropertiesToolbar extends Component<AllProps> {

    static defaultProps = defaultProps;

    /**
     * @param props
     */
    constructor( props : AllProps ) {
        super( props );

        this.onViewOptionChange = this.onViewOptionChange.bind( this );
    }

    /**
     * The handler for view option change.
     *
     * @param {String} name
     * @param {Boolean} checked
     *
     * @private
     */
    onViewOptionChange( name : string, checked : boolean ) {
        this.props.setParam?.( this.props.uid, name as keyof DetailProps, checked );
    }

    /**
     * REACT lifecycle method
     */
    render() {
        const {
                  uid,
                  showEmptyProperties,
                  showPropertyDefaults,
                  showViewOptionsButton,
                  className: toolbarClassName
              }                                          = this.props,
              layoutComponents : ToolbarLayoutComponents = {
                  left : [],
                  right: []
              };

        // left

        // right
        if ( showViewOptionsButton ) {
            layoutComponents.right.push( {
                type  : 'viewOptionsMenu',
                params: {
                    key: `${uid}_viewOptions`,

                    uid: uid,

                    options           : [
                        {
                            name : 'showEmptyProperties',
                            label: __( 'YN.base.viewOptions.showEmptyProperties.label' ),
                            value: showEmptyProperties
                        },
                        {
                            name : 'showPropertyDefaults',
                            label: __( 'YN.base.viewOptions.propertyDefaults.label' ),
                            value: showPropertyDefaults
                        }
                    ],
                    onViewOptionChange: this.onViewOptionChange
                }
            } );
        }

        const toolbarComponents : ToolbarComponents = getToolbarComponents( layoutComponents );

        return <Toolbar
            left={toolbarComponents.left}
            right={toolbarComponents.right}
            className={`${toolbarClassName} yn-panel-toolbar yn-panel-toolbar-border-none-bottom yn-toolbar-horizontal-separator-bottom`}
            style={{ zIndex: 5 }}
        />;
    }
}

/**
 * REDUX stuff
 */
function mapStateToProps( state : StoreState ) : StateProps {
    const retVal : StateProps = {
        user: undefined
    };

    // get some session user information
    if ( state.session?.user ) {
        retVal.user = state.session.user;
    }

    return retVal;
}

/**
 * REDUX stuff
 */
function mapDispatchToProps( dispatch : Dispatch ) {
    return bindActionCreators( Actions, dispatch );
}

export default connect<StateProps, ActionProps, ComponentProps, StoreState>( mapStateToProps, mapDispatchToProps )( PropertiesToolbar );
